__turbopack_context__.v({
  "highlightCard": "FeaturedEvent-module-scss-module__ZhmS4q__highlightCard",
  "highlightLabel": "FeaturedEvent-module-scss-module__ZhmS4q__highlightLabel",
  "highlightSection": "FeaturedEvent-module-scss-module__ZhmS4q__highlightSection",
  "modalAction": "FeaturedEvent-module-scss-module__ZhmS4q__modalAction",
  "modalActions": "FeaturedEvent-module-scss-module__ZhmS4q__modalActions",
  "modalArtwork": "FeaturedEvent-module-scss-module__ZhmS4q__modalArtwork",
  "modalArtworkImage": "FeaturedEvent-module-scss-module__ZhmS4q__modalArtworkImage",
  "modalContent": "FeaturedEvent-module-scss-module__ZhmS4q__modalContent",
  "modalDescription": "FeaturedEvent-module-scss-module__ZhmS4q__modalDescription",
  "modalError": "FeaturedEvent-module-scss-module__ZhmS4q__modalError",
  "modalEyebrow": "FeaturedEvent-module-scss-module__ZhmS4q__modalEyebrow",
  "modalTitle": "FeaturedEvent-module-scss-module__ZhmS4q__modalTitle",
  "pinButton": "FeaturedEvent-module-scss-module__ZhmS4q__pinButton",
  "pinTooltip": "FeaturedEvent-module-scss-module__ZhmS4q__pinTooltip",
  "pinTooltipAnchor": "FeaturedEvent-module-scss-module__ZhmS4q__pinTooltipAnchor",
  "pinTooltipCopy": "FeaturedEvent-module-scss-module__ZhmS4q__pinTooltipCopy",
  "pinTooltipDescription": "FeaturedEvent-module-scss-module__ZhmS4q__pinTooltipDescription",
  "pinTooltipPreview": "FeaturedEvent-module-scss-module__ZhmS4q__pinTooltipPreview",
  "pinTooltipTitle": "FeaturedEvent-module-scss-module__ZhmS4q__pinTooltipTitle",
  "pinnedButton": "FeaturedEvent-module-scss-module__ZhmS4q__pinnedButton",
  "replaceModal": "FeaturedEvent-module-scss-module__ZhmS4q__replaceModal",
  "replaceModalBody": "FeaturedEvent-module-scss-module__ZhmS4q__replaceModalBody",
});
